import { render, staticRenderFns } from "./LawNormTable.vue?vue&type=template&id=6334861e&scoped=true"
import script from "./LawNormTable.vue?vue&type=script&lang=js"
export * from "./LawNormTable.vue?vue&type=script&lang=js"
import style0 from "./LawNormTable.vue?vue&type=style&index=0&id=6334861e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334861e",
  null
  
)

export default component.exports